import React, { ChangeEvent, memo, useState } from "react";
import { isNil } from "ramda";
import {
  Grid,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";

import { Data, caType } from "../../../store/cert/types";
import { getPEMFormat } from "../../../store/cert/queries";
import pageStyles from "../../pageStyles";
import { FormikProps, useFormikContext, FastField } from "formik";
import CertDialog from "./CertDialog";
import TextInput from "../../../common/formElements/TextInput";

interface CertIssuerSection {
  isCertNew?: boolean;
  caMap?: caType[];
}

const CertIssuerSection = ({ isCertNew, caMap }: CertIssuerSection) => {
  const classes = pageStyles();
  const [showButtons, setShowButtons] = useState(true);
  const formProps = useFormikContext<FormikProps<Data>>();
  const { setFieldValue } = formProps;
  const values = (formProps.values as unknown) as Data;

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname="attributes.CADescription"
          label="CA Description"
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname="attributes.CASerialNumber"
          label="CA Serial Number"
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <FormControl fullWidth variant="outlined">
          <InputLabel id="changeCA">
            {isCertNew ? "Select Issuer CA" : "Update Issuer CA"}
          </InputLabel>
          <FastField
            name="changeCA"
            as={Select}
            fullWidth
            labelId="changeCA"
            variant="outlined"
            value={
              caMap &&
              caMap.find((c) => c.serial === values.attributes.CASerialNumber)
            }
            onChange={(
              event: ChangeEvent<HTMLInputElement>,
              val: caType | null
            ) => {
              const ca = (event.target.value as unknown) as caType;
              console.log(ca);
              !isNil(val) && setFieldValue("attributes.CADescription", ca.desc);
              setFieldValue("attributes.CASerialNumber", ca.serial);
              setShowButtons(!ca);
            }}
          >
            {caMap &&
              caMap.map((ca: caType, index) => {
                return (
                  <MenuItem key={index} value={ca as any}>
                    {ca.desc}-{ca.serial}
                  </MenuItem>
                );
              })}
          </FastField>
        </FormControl>
      </Grid>

      {!isCertNew && showButtons && (
        <Grid item xs={12}>
          <hr className={classes.devide} />
          <CertDialog
            title={"CA Certificate in PEM Format"}
            certData={getPEMFormat(values.attributes?.CAX509Chain)}
          />
          <Box marginLeft={3} component="span">
            <CertDialog
              title={"CA Certificate in DER Format"}
              certData={values.attributes?.CAX509DER}
            />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default memo(CertIssuerSection);
